// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"387":"62a3253e","467":"3b932765","487":"9db4b676","856":"aa0c7623"}[chunkId] + ".js";
};